<template>
    <div class="mt-8">
        <nav class="flex flex-wrap items-start gap-x-8 border-b border-black/15 text-center sm:items-end md:gap-x-12 lg:flex-nowrap xl:gap-x-16">
            <a v-for="(item, idx) in value" :href="`#${kebabCase(item.label)}`" :class="{ active: idx == activeIndex }" @click.prevent="activeIndex = idx">
                {{ item.label }}
            </a>
        </nav>

        <div class="relative mt-9 h-screen transition-all" :style="{ maxHeight: currentHeight + 'px' }">
            <div v-for="(item, idx) in value" :class="{ active: activeIndex == idx }" class="panel" ref="panels">
                <ul class="kb-section-grid">
                    <li v-for="gridItem in item.items">
                        <strong>{{ gridItem.label }}</strong>
                        &ndash; {{ gridItem.description }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import { kebabCase } from 'lodash';
import { onMounted, ref } from 'vue';

defineProps({ value: { type: Array, required: true } });

const activeIndex = ref(0);
const currentHeight = ref(0);
const panels = ref(null);

onMounted(() => {
    updateHeight(0);
});

function updateHeight(idx) {
    const targetEl = panels.value[idx];

    currentHeight.value = targetEl.getBoundingClientRect().height;
}
</script>

<style scoped>
a {
    @apply border-b-4 border-white py-2 text-[18px] font-bold uppercase leading-tight text-lab-gray-500 transition-all duration-200 hover:text-lab-gray-800 sm:text-xs md:text-sm lg:text-[18px];
}

a.active {
    @apply text-lab-gray-800;

    border-color: var(--primary-color);
}

.panel {
    @apply absolute left-0 top-0 opacity-0 transition-opacity duration-200;
}

.panel.active {
    @apply opacity-100;
}
</style>
